import React from 'react';
import theme from './DocumentListItemShort.module.scss';
import { BaseDocument, ResidentialUnitDocument } from '@/types';
import { getOpenDocumentUrl } from '@/services/documents';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding, faHome, faEyeSlash } from '@fortawesome/pro-light-svg-icons';
import { Trans } from '@lingui/react/macro';
import { useDocumentType } from '@/utils/hooks';
import { FileIcon } from '@ygtechnologies/bygr-frontend-component-library';

interface DocumentListItemShortProps {
    document: BaseDocument;
}

const DocumentListItemShort: React.FC<DocumentListItemShortProps> = ({ document }) => {
    const renderTypeIcon = () => {
        return (
            <FontAwesomeIcon
                className={theme.typeIcon}
                icon={(document as ResidentialUnitDocument).isProjectDocument ? faBuilding : faHome}
            />
        );
    };
    const documentType = useDocumentType(document.documentTypeId);

    return (
        <>
            <a
                className={theme.container}
                href={getOpenDocumentUrl(document.lastVersionId)}
                target="_blank"
                rel="noreferrer noopener">
                <div className={theme.fileIconWrapper}>
                    <FileIcon value={document.lastVersionFileMetadata} size="3x" />
                </div>

                <div>
                    <div>
                        {renderTypeIcon()}
                        {documentType && documentType.name}
                    </div>
                    <small>
                        {document.name} | <Trans id="versionShortHand">v {document.versionCount + 1}</Trans>
                    </small>
                    <small>
                        {(document as ResidentialUnitDocument).hideFromBuyer && (
                            <span className={theme.hideFromBuyerInfoText}>
                                <FontAwesomeIcon icon={faEyeSlash} />
                                <Trans>hidden from buyer</Trans>
                            </span>
                        )}
                    </small>
                </div>
            </a>
            <hr className={theme.separator} />
        </>
    );
};

export default DocumentListItemShort;
